import React from "react";
import { Modal } from "react-bootstrap";
import YouTubeEmbed from "./YoutubeEmbed";

interface YoutubeModalProps {
    show: boolean;
    onHide: () => void;
    videoId: string;
    title?: string;
}

export const YoutubeModal: React.FC<YoutubeModalProps> = ({
    show,
    onHide,
    videoId,
    title = "YouTube Video",
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            style={{ opacity: 1, zIndex: 9999, paddingTop: "10%" }}
            aria-labelledby="contained-modal-title-vcenter"
            onEscapeKeyDown={() => onHide()}
            backdropClassName="modal-backdrop foo-modal-backdrop in"
        >
            <YouTubeEmbed
                videoId={videoId}
                title={title}
            />
        </Modal>
    );
};